import * as orders from "./orders";

export const gshop = {
    ...orders
}